import React from 'react';
import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import { Alert, IconButton, COLORS } from '@livecommerce/design-system';
import { useLocalization } from 'contexts/LocalizationContext.jsx';

const alertStyle = css`
  width: calc(100% - 16px);
  height: 56px;
  margin: 8px;
  border-radius: 8px;
  grid-column: 1 / 3;
  grid-row: 1 / 2;
`;

const textContainerStyle = css`
  width: 100%;
`;

const descriptionStyle = css`
  width: 100%;
`;

const titleStyle = css`
  text-align: center;
  width: 100%;
`;

const StyledAlert = styled(Alert)`
  background-color: ${COLORS.orange_500};
`;

const NotificationAlert = ({ notification, handleBannerNotificationDismiss }) => {
  const { source, id } = notification;
  const { t } = useLocalization();
  return (
    <StyledAlert
      dataTestId="notificationAlertBanner"
      title={t(`bannerNotifications.${source}-text`)}
      variant="feedback"
      className={alertStyle}
      textContainerProps={{ className: textContainerStyle }}
      titleProps={{ className: titleStyle }}
      descriptionProps={{ className: descriptionStyle }}
      customRightElement={(
        <IconButton
          variant="transparent"
          iconName="cross"
          onClick={() => handleBannerNotificationDismiss(id)}
          theme="dark"
        />
      )}
    />
  );
};

export default NotificationAlert;
